import { create } from 'zustand'

import { type OnboardingNavigationState } from '../types/OnboardingNavigationState'

export const useOnboardingNavigation = create<OnboardingNavigationState>()(
  (set) => ({
    totalSteps: 4,
    currentStep: 1,
    prevStep: () =>
      set((state) => ({ ...state, currentStep: state.currentStep - 1 })),
    nextStep: () =>
      set((state) => ({ ...state, currentStep: state.currentStep + 1 })),
    moveToStep: (step: number) =>
      set((state) => ({ ...state, currentStep: step })),
    setTotalSteps: (total: number) =>
      set((state) => ({ ...state, totalSteps: total })),
  })
)
